export var environment = {
  //VARIAVEIS DE TESTE
  // API_URL: 'http://prover.develop/api-nova/v4',
  // API_ANTIGA_URL: 'http://prover.develop/api/v3',
  // DOWNLOAD_URL: 'http://prover.develop/public/download',
  // IMG_URL: 'http://prover.develop/public/img',
  // BACKEND_IMG_URL: 'http://prover.develop/backend/anexo/img?f=',

  /** ENVIRONMENT PRODUÇÃO **/

  API_URL: 'https://portal.sistemaprover.com.br/api/v4',
  API_ANTIGA_URL: 'https://sis.sistemaprover.com.br/api/v3',
  DOWNLOAD_URL: 'https://sis.sistemaprover.com.br/public/download',
  IMG_URL: 'https://sis.sistemaprover.com.br/public/img',
  BACKEND_IMG_URL: 'https://sis.sistemaprover.com.br/backend/anexo/img?f=',
  PORTAL_URL: 'https://portal.sistemaprover.com.br',

  /** ENVIRONMENT ANTIGO HOMOLOG **/

  // API_URL: 'https://h-portal.sistemaprover.com.br/api/v4',
  // API_ANTIGA_URL: 'https://h-sis.sistemaprover.com.br/api/v3',
  // DOWNLOAD_URL: 'https://h-sis.sistemaprover.com.br/public/download',
  // IMG_URL: 'https://h-sis.sistemaprover.com.br/public/img',
  // BACKEND_IMG_URL: 'https://h-sis.sistemaprover.com.br/backend/anexo/img?f=',
  // PORTAL_URL: 'https://h-portal.sistemaprover.com.br',

  /** ENVIRONMENT QA **/ 

  // API_URL: 'https://qa.portal.provertecnologia.com.br/api/v4',
  // API_ANTIGA_URL: 'https://qa.sis.provertecnologia.com.br/api/v3',
  // DOWNLOAD_URL: 'https://qa.sis.provertecnologia.com.br/public/download',
  // IMG_URL: 'https://qa.sis.provertecnologia.com.br/public/img',
  // PORTAL_URL: 'https://qa.portal.provertecnologia.com.br',
  // BACKEND_IMG_URL: 'https://qa.sis.provertecnologia.com.br/backend/anexo/img?f=',
  // INTEGRACAO_URL: https://inscricoes.qa.prover.zhav.dev

  LOGO_URL: 'https://sis.sistemaprover.com.br/services/loadImg',
  URL_CONTRIBUA: 'https://portal.sistemaprover.com.br/frontend/contribuicao/listar?t=',
  INTEGRACAO_URL: 'https://integracao.prover.app',
  APP_VERSION: '1735',
};

export var firebase_options = {
  apiKey: 'AIzaSyBiyrPillroxK1FXVS-aCQxMBThqdBHWWU',
  authDomain: 'sistemaprover2015.firebaseapp.com',
  databaseURL: 'https://sistemaprover2015.firebaseio.com',
  projectId: 'sistemaprover2015',
  storageBucket: 'sistemaprover2015.appspot.com',
  messagingSenderId: '536983349899',
  vapidKey: 'BMqQ7fHnS2KiVYIyN1Q_55sRWma-7c4BXZNuBLDe2I3UwCv3-0-l8W3bj43oxkLQB8TW4Agolifx9rubDmvMyHQ',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts